export default __webpack_public_path__ + "3e7ad09fab5a6f6c1dcd9ded4d5fc870.png";